import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// Read admin enable flag from env; normalize to boolean
const enableAdmin = (process.env.VUE_APP_ENABLE_ADMIN || '').toLowerCase() === 'true'

// Build base routes first (non-admin)
const routes = [
  {
    path: '/home',
    name: 'Home',
    component: () => import('./views/HomeView/HomeView.vue'),
  },
  {
    path: '/market',
    // 首页即市场：`/` 与 `/market` 渲染同一页面。
    // 这里用 alias 而不是 redirect —— redirect 会把地址栏改成 `/market`，
    // 而 alias 让访问 `/` 时 URL 保持 `/`（首页不出现 market 字样）。
    alias: '/',
    component: () => import('./views/Layouts/app.layout.vue'),
    children: [
      {
        path: '',
        name: 'market',
        component: () => import('./views/App/market.vue'),
      },
      {
        // 旧的 PRDS 领取页依赖主网 PRDS_CLAIM 合约（测试网无地址，点了没反应）。
        // 现在 Claim 就是「领测试币」，入口在资金页弹窗，这里保留跳转兼容老链接。
        path: '/claim',
        redirect: '/deposit?claim=1',
      },
      {
        path: '/detail/:id',
        name: 'market-detail',
        component: () => import('./views/App/market-detail.vue'),
      },
      {
        path: '/portfolio',
        name: 'portfolio',
        component: () => import('./views/App/portfolio.vue'),
      },
      {
        // 平台动态（Activity）：全站参与流水时间线，3 秒自动刷新
        path: '/activity',
        name: 'activity',
        component: () => import('./views/App/activity.vue'),
      },
      {
        path: '/bridge',
        name: 'bridge',
        component: () => import('./views/TokenMove/index.vue'),
      },
      {
        path: '/deposit',
        name: 'deposit',
        component: () => import('./views/Fund/Deposit.vue'),
      },
      {
        path: '/issue',
        name: 'issue',
        component: () => import('./views/App/issue.vue'),
      },
    ],
  },
  {
    path: '/nft',
    component: () => import('./views/Layouts/app.layout.vue'),
    children: [
      {
        path: '',
        component: () => import('./views/NFT/layout.vue'),
        children: [
          {
            path: '',
            name: 'nftSale',
            component: () => import('./views/NFT/index.vue'),
          },
          {
            path: 'packet',
            name: 'nftPacket',
            component: () => import('./views/NFT/packet.vue'),
          },
          {
            path: 'market',
            name: 'nftMarket',
            component: () => import('./views/NFT/market.vue'),
          },
          {
            // 出租市场（收租理财）：交易属性，归属 License
            path: 'rental',
            name: 'nftRental',
            component: () => import('./views/NFT/rental.vue'),
          },
          {
            path: 'detail/:id',
            name: 'nft-detail',
            component: () => import('./views/NFT/nft-detail.vue'),
          },
        ],
      },
    ],
  },
  {
    // Community（社区）：排行 / 比赛 / 推荐关系等社交玩法集合，
    // 与 License（销售/转让/租赁的交易板块）分离，不共用页面
    path: '/community',
    component: () => import('./views/Layouts/app.layout.vue'),
    children: [
      {
        path: '',
        component: () => import('./views/Community/layout.vue'),
        children: [
          {
            path: '',
            redirect: '/community/leaderboard',
          },
          {
            // 战绩榜（含交易员主页抽屉，支持 ?address= 直达）
            path: 'leaderboard',
            name: 'nftLeaderboard',
            component: () => import('./views/NFT/leaderboard.vue'),
          },
          {
            // 推广中心（邀请链接 / 返佣流水 / 推广榜）
            path: 'referral',
            name: 'nftReferral',
            component: () => import('./views/NFT/referral.vue'),
          },
        ],
      },
    ],
  },
  // 旧路径兼容：增长功能曾挂在 /nft 下
  {
    path: '/nft/leaderboard',
    redirect: '/community/leaderboard',
  },
  {
    path: '/nft/referral',
    redirect: '/community/referral',
  },
]

// Conditionally add Admin route
if (enableAdmin) {
  routes.push({
    path: '/admin',
    name: 'Admin',
    component: () => import('./views/Admin/admin.vue')
  })
}

// 兜底路由必须在创建 Router 之前注册，否则不会生效
routes.push({
  path: '*',
  redirect: '/',
})

// Export router with the computed routes
// base 来自 publicPath（见 vue.config.js）：子路径部署时（如 /prediction/）
// 浏览器地址栏带前缀，而 history 模式需要知道去哪里匹配路由。
export default new Router({
  mode: 'history',
  base: process.env.BASE_URL || '/',
  routes,
})
